import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import TripAdd from './components/TripAdd';
import TripsDisplay from './components/TripsDisplay';
import SearchTrip from './components/SearchTrip';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './css/app.css';
import Bars from './components/Bars';
import HikeAdd from './components/HikeAdd';
import ToggleTabs from './components/ToggleTabs';
import HikeDisplay from './components/HikeDisplay';
import TripsNearbyDisplay from './components/TripsNearbyDisplay';
import { getCoordinates } from './components/utils/geocode'


function StartPage() {

  const LIMIT = 25;
  const DEBOUNCE_TIME = 850;

  const isFirstRender = useRef(true)
  const searchInputRef = useRef(null);

  const [activeTab, setActiveTab] = useState("trips");
  const [disabledToggleTab, setDisabledToggleTab] = useState(false)

  const [trips, setTrips] = useState([]);
  const [hikes, setHikes] = useState([]);
  const [nearTrips, setNearTrips] = useState([]); 
  
  const [filteredTrips, setFilteredTrips] = useState([]);
  const [filteredHikes, setFilteredHikes] = useState([]);
 
  const [pageTrips, setPageTrips] = useState(1);
  const [pageHikes, setPageHikes] = useState(1);
  const [pageNearTrips, setPageNearTrips] = useState(1);

  const [pageFilteredTrips, setPageFilteredTrips] = useState(1);
  const [pageFilteredHikes, setPageFilteredHikes] = useState(1);

  const [searchQuery, setSearchQuery] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const [lastSearchedQuery, setLastSearchedQuery] = useState('');
  
  const [hasMoreTrips, setHasMoreTrips] = useState(true);
  const [hasMoreHikes, setHasMoreHikes] = useState(true);
  const [hasMoreNearTrips, setHasMoreNearTrips] = useState(false);
  
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  
  const [addMode, setAddMode] = useState(null); // 'trip' albo 'hike'
  const [addSection, setAddSection] = useState(false);
  

    




  const fetchTrips = async () => {

    setLoading(true);
    setIsSearching(false);
    setPageTrips(1);

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/trips?page=1&limit=${LIMIT}`, { withCredentials: true });
      setTrips(res.data.data);
      setFilteredTrips([]);
      setHasMoreTrips(res.data.total > LIMIT);
    } catch {
      toast.error('Nie udało się załadować przejazdów.');
    } finally {
      setLoading(false);
    }
  };



  const fetchNearTrips = async (excludeIds, cityName, page = 1) => {
  
    if (!cityName || cityName.trim().length < 3) return;

    const coords = await getCoordinates(cityName);
    if (!coords) return;


    try {
    
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/trips/near?lat=${coords.lat}&lon=${coords.lon}&page=${page}&limit=${LIMIT}&excludeIds=${excludeIds}`,
        { withCredentials: true }
      );

    
      if (page === 1) setNearTrips(res.data.data);
      else setNearTrips(prev => [...prev, ...res.data.data]);


      setPageNearTrips(page);
      setHasMoreNearTrips(res.data.total > page * LIMIT);
    } catch (err) {
      toast.error("Błąd podczas pobierania pobliskich przejazdów.");
    }
  };


  const fetchHikes = async () => {

    setLoading(true);
    setIsSearching(false);
    setPageHikes(1);

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/hikes?page=1&limit=${LIMIT}`, { withCredentials: true });
      setHikes(res.data.data);
      setFilteredHikes([]);
      setHasMoreHikes(res.data.total > LIMIT);
    } catch {
      toast.error('Nie udało się załadować wyjść na szlak.');
    } finally {
      setLoading(false);
    }
  };



  const handleSearch = async () => {

    if (activeTab === 'trips') {
      setPageTrips(1);
      setHasMoreTrips(true);
    } else {
      setPageHikes(1);
      setHasMoreHikes(true);
    }

    setNearTrips([]);
    setPageNearTrips(1);
    setHasMoreNearTrips(false);

    if (searchQuery.trim() === '') {
      
      if(activeTab === 'trips') fetchTrips();
      else fetchHikes()

      return;
    }

    if (searchQuery.length < 3) return;

    setLoading(true);
    setIsSearching(true);
    setPageTrips(1);
    setPageHikes(1);

    try {
       if(activeTab === 'trips'){

        const res = await axios.get(`${process.env.REACT_APP_API_URL}/trips?name=${encodeURIComponent(searchQuery)}&page=1&limit=${LIMIT}`, { withCredentials: true });
      
        setFilteredTrips(res.data.data);
        setHasMoreTrips(res.data.total > LIMIT);
        setPageFilteredTrips(1);
        setLastSearchedQuery(searchQuery); // ustaw dopiero po odpowiedzi
        if (res.data.data.length === 0) {
          toast.info(<div>Brak przejazdów dla: " <i>{searchQuery}</i> "</div>);
        } else {

          toast.success(
            <div>
              Ilość przejazdów dla " <i>{searchQuery}</i> " : {res.data.data.length}
            </div>
          );
        }
       }
       else{
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/hikes?name=${encodeURIComponent(searchQuery)}&page=1&limit=${LIMIT}`, { withCredentials: true });
      
        setFilteredHikes(res.data.data);
        setHasMoreHikes(res.data.total > LIMIT);
        setPageFilteredHikes(1);
        setLastSearchedQuery(searchQuery); // ⬅️ ustaw dopiero po odpowiedzi
        if (res.data.data.length === 0) {
          toast.info(<div>Brak wyjść na szlak dla: " <i>{searchQuery}</i> "</div>);
        } else {

          toast.success(
            <div>
              Ilość wyjśc na szlak dla " <i>{searchQuery}</i> " : {res.data.data.length}
            </div>
          );
        }
       }
      
    } catch {
      toast.error('Błąd podczas wyszukiwania.');
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    if (activeTab === "trips") fetchTrips();
    else fetchHikes();
  }, []);


  useEffect(() => {
  if (
    activeTab !== 'trips' ||
    !isSearching ||
    searchQuery.trim().length < 3
  ) return;

  const excludeIds = filteredTrips.length ? filteredTrips.map(ft => ft.id).join(',') : ''
  
  fetchNearTrips(excludeIds, searchQuery, 1);

}, [filteredTrips]);





  useEffect(() => {
    
    setSearchQuery("");
    setIsSearching(false);
    setFilteredTrips([]);
    setFilteredHikes([]);
    setNearTrips([]);
    setLastSearchedQuery("");
    setDisabledToggleTab(false);

    if (activeTab === "trips") fetchTrips();
    else fetchHikes();

  }, [activeTab]);



  useEffect(() => {
  
    if (isFirstRender.current) {
      isFirstRender.current = false;
    return;
  }

  setDisabledToggleTab(true);

  if (searchQuery.trim().length === 0) {
    
    const timeout = setTimeout(() => {
      setIsSearching(false);
      setFilteredTrips([]);
      setFilteredHikes([]);
      setNearTrips([]);
      setLastSearchedQuery("");
      
     // setTrips([]);
    //  setHikes([]);

      // RESET PAGINACJI
      setPageTrips(1);
      setPageFilteredTrips(1);
      setPageHikes(1);
      setPageFilteredHikes(1);
      setPageNearTrips(1);

      setHasMoreTrips(true);
      setHasMoreHikes(true);
      setHasMoreNearTrips(false);
      
      if (activeTab === 'trips') fetchTrips();
      else fetchHikes();

      setDisabledToggleTab(false);
    },  DEBOUNCE_TIME);

    return () => clearTimeout(timeout);
  }
  
  if (searchQuery.trim().length < 3) {
    const timeout = setTimeout(() => {
      setDisabledToggleTab(false); // tylko odblokowanie zakładek
    }, DEBOUNCE_TIME);

    return () => clearTimeout(timeout);
  }

  const debounce = setTimeout(async () => {
    try {
      await handleSearch();
    } finally {
      setDisabledToggleTab(false);
    }
  }, DEBOUNCE_TIME);

  return () => clearTimeout(debounce);


}, [searchQuery]);



  const loadMore = async () => {

    if (loadingMore) return;  
    setLoadingMore(true);

  

    try {

      if(activeTab === 'trips'){

        const nextPageTrips = pageTrips + 1;
        
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/trips?page=${nextPageTrips}&limit=${LIMIT}`, { withCredentials: true });
        setTrips(prev => [...prev, ...res.data.data]);
        setPageTrips(nextPageTrips);
        setHasMoreTrips((nextPageTrips * LIMIT) < res.data.total);
      }
      else{

        const nextPageHikes = pageHikes + 1;

        const res = await axios.get(`${process.env.REACT_APP_API_URL}/hikes?page=${nextPageHikes}&limit=${LIMIT}`, { withCredentials: true });
        setHikes(prev => [...prev, ...res.data.data]);
        setPageHikes(nextPageHikes);
        setHasMoreHikes((nextPageHikes * LIMIT) < res.data.total);
      }
      
    } catch {
      toast.error('Błąd podczas ładowania ...');
    } finally {
      setLoadingMore(false);
    }
  };

  const loadMoreFiltered = async () => {

    if (loadingMore || !searchQuery.trim()) return;
    setLoadingMore(true);

    try {
      
      if(activeTab === 'trips'){

        const nextPageTrips = pageFilteredTrips + 1;

        const res = await axios.get(`${process.env.REACT_APP_API_URL}/trips?name=${encodeURIComponent(searchQuery)}&page=${nextPageTrips}&limit=${LIMIT}`, { withCredentials: true });
        setFilteredTrips(prev => [...prev, ...res.data.data]);
        setPageFilteredTrips(nextPageTrips);
        setHasMoreTrips(nextPageTrips * LIMIT < res.data.total);
      }
      else{

        const nextPageHikes = pageFilteredHikes + 1;

        const res = await axios.get(`${process.env.REACT_APP_API_URL}/hikes?name=${encodeURIComponent(searchQuery)}&page=${nextPageHikes}&limit=${LIMIT}`, { withCredentials: true });
        setFilteredHikes(prev => [...prev, ...res.data.data]);
        setPageFilteredHikes(nextPageHikes);
        setHasMoreHikes(nextPageHikes * LIMIT < res.data.total);
      }
    } catch {
      toast.error('Błąd przy ładowaniu wyników.');
    } finally {
      setLoadingMore(false);
    }
  };


  const scrollToSearchInput = ({ focus = false } = {}) => {
  if (!searchInputRef.current) return;

  const input = searchInputRef.current.querySelector('input');
  if (!input) return;

  const offset = -150;
  const top =
    searchInputRef.current.getBoundingClientRect().top +
    window.scrollY +
    offset;

  window.scrollTo({ top, behavior: 'smooth' });

  if (focus) {
    setTimeout(() => {
      input.focus({ preventScroll: true });
    }, 250);
  }
};



  const handleAddClick = (type) => {
    setAddMode(type);
    setAddSection(true);
  };

  const uniqueTrips = (isSearching ? filteredTrips : trips).filter(
  (trip, index, self) => self.findIndex(t => t.id === trip.id) === index
);
  

  return (
      
    <>
      <ToastContainer
        className="userSelectNone"
        position="top-right"    // Toast wyświetla się na górze
        autoClose={1800}
        hideProgressBar={true}
        limit={3}
        style={{
          marginTop: '28vh',
          zIndex: 9999,         // Upewniamy się, że toast jest na wierzchu
          pointerEvents: 'none', // Upewniamy się, że toast nie blokuje interakcji
        }}
      />
     
      <div className="container" >

        {/* rozmycie stąd*/}

        <div className={`mainContent ${addSection ? 'blurred' : ''}`}>

          <Bars onAddClick={handleAddClick} onSearchClick={()=>scrollToSearchInput({focus: true})} activeTab={activeTab}/> 
      
          <h3 className="h3-header userSelectNone"  aria-label="Górska Podwózka">
            <img src="/logo/logoApp.png" alt="logo"  className="logo"  />  
            GórskaPodwózka            
          </h3>

          <p className="sub-header userSelectNone">
            Znajdź przejazdy lub wyprawy górskie albo dodaj własne i zabierz kogoś ze sobą. Zerknij też na górską pogodę.
          </p>
       

          <ToggleTabs active={activeTab} onChange={setActiveTab} setQuery={setSearchQuery} disabled={disabledToggleTab} />
          
          
          {activeTab === 'trips' ?
            <button className="btn btn-add-trip" onClick={()=>handleAddClick('trip')}>Dodaj Przejazd</button>:
            <button className="btn btn-add-trip" onClick={()=>handleAddClick('hike')}>Dodaj Wyprawę</button>
          }

            <div ref={searchInputRef} >
              
            <SearchTrip query={searchQuery} setQuery={setSearchQuery} handleFocus={scrollToSearchInput} activeTab = {activeTab}  />
           
            </div>
        
        
          {loading && <p className="loading-spinner">Ładowanie ...</p>}

          {!loading && (
            
            activeTab === "trips" ? (
              
              <TripsDisplay
                trips={uniqueTrips}
                allViewTripsLength = {trips.length}
                isSearching = {isSearching}
                loadMore={isSearching ? loadMoreFiltered : loadMore}
                hasMore={hasMoreTrips}
                loading={loadingMore}
              />
            ) : (
              <HikeDisplay 
                hikes={ isSearching  ? filteredHikes : hikes} 
                allViewHikesLength = {hikes.length}
                loadMore={isSearching ? loadMoreFiltered : loadMore}
                hasMore={hasMoreHikes}
                loading={loadingMore}
              />
            )        
          )}


          {
          activeTab==='trips'?
          !loading &&
            isSearching &&
            searchQuery === lastSearchedQuery &&
            filteredTrips.length === 0 &&
            searchQuery.trim().length >= 3 && (
              <p className='userSelectNone' style={{ marginTop: '2vh', marginBottom: 0 }}>
                Brak przejazdów dla: <strong>{searchQuery}</strong>
              </p>
          ): !loading &&
            isSearching &&
            searchQuery === lastSearchedQuery &&
            filteredHikes.length === 0 &&
            searchQuery.trim().length >= 3 && (
              <p className='userSelectNone' style={{ marginTop: '2vh' }}>
                Brak wypraw dla: <strong>{searchQuery}</strong>
              </p>)
            }
          
            {activeTab === 'trips' && nearTrips.length > 0 && (

              <TripsNearbyDisplay
                trips={nearTrips}
                allViewTripsLength = {nearTrips.length}
                searchQuery={searchQuery}
                loadMore={() => {
                  const excludeIds = filteredTrips.length ? filteredTrips.map(ft => ft.id).join(',') : '';
                  fetchNearTrips(excludeIds, searchQuery, pageNearTrips + 1);
                }}
                hasMore={hasMoreNearTrips}
                loading={loadingMore}
              />

              

            )}

          

          {loadingMore && <p>Ładowanie ...</p>}

      </div>

      {/* ⬇️ To NIE jest rozmywane */}
      {addSection && addMode === 'trip' && (
        <TripAdd fetchTrips={fetchTrips} handleCloseForm={() => setAddSection(false)} />
      )}

      {addSection && addMode === 'hike' && (
        <HikeAdd fetchHikes={fetchHikes} handleCloseForm={() => setAddSection(false)} />
      )}
     
      </div>
    </>
  );
}

export default StartPage;
